import '../styling/global.css';
import wedooimage from '../assets/wedoo_logo.webp';
import trustmeeimg from '../assets/trustmee_logo.webp';
import BackgroundEffect from '../components/BackgroundEffect';
import { useNavigate } from 'react-router-dom';

const Products = () => {
    const navigate = useNavigate();

    const goToTrustmee = () => {
        navigate('/product-trustmee'); 
    };

    const goToWedoo = () => {
        navigate('/product-wedoo'); 
    };

    return (
        <div className="products-page">
            <BackgroundEffect />
            <h1>Our Products</h1>
            <p>Innovative solutions designed to drive your business forward</p>
            <div className="product-card">
                <div className="wedoo">
                    <img src={wedooimage} alt="Wedoo logo" className="wedoo-image" />
                    <button style={{ minWidth: 220 }} onClick={goToWedoo} className='blue-button'>
                        Project Wedoo
                    </button>
                </div>
                <div className="trustmee">
                    <img src={trustmeeimg} alt="Trustmee logo" className="hero-image" />
                    <button style={{ minWidth: 220 }} onClick={goToTrustmee} className='blue-button'>
                        Project Trustmee
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Products;
